import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-ExportVariantsModal',
	row: 'c-ExportVariantsModal__Row',
	rowLabel: 'c-ExportVariantsModal__RowLabel',
	sectionLabel: 'c-ExportVariantsModal__SectionLabel',
	variantRow: 'c-ExportVariantsModal__VariantRow',
	variantRowDisabled: 'c-ExportVariantsModal__VariantRow--disabled',
	help: 'c-ExportVariantsModal__Help',
};

export const Style = {
	[CSS.container]: {
		width: '420px',
	},
	[CSS.row]: {
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'space-between',
		gap: DefaultTheme.space(4),
		'margin-bottom': DefaultTheme.space(4),
	},
	[CSS.rowLabel]: {
		'white-space': 'nowrap',
	},
	[CSS.sectionLabel]: {
		'margin-bottom': DefaultTheme.space(2),
	},
	[CSS.variantRow]: {
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(2),
		padding: `${DefaultTheme.space(2)} 0`,
		'border-bottom': `1px solid ${DefaultTheme.font.color.divider}`,
	},
	[CSS.variantRowDisabled]: {
		color: DefaultTheme.font.color.disabled,
	},
	[CSS.help]: {
		color: DefaultTheme.font.color.disabled,
		'font-size': '0.85rem',
		'margin-top': DefaultTheme.space(4),
	},
};
